import styled, { css } from 'styled-components';

export const HintsContainer = styled.div`
    ${(props) => props.theme.typography.text}
    color: ${(props) => props.theme.palette.textLight};
    display: flex;
    flex-direction: column;
    align-items: center;
    min-height: 30px;
    min-width: 320px;
    transition: all 0.3s;
    position: absolute;
    top: 65px;
    z-index: 1000;

    &.hints {
        min-height: 52px;
        ${(props) => props.theme.breakpointTo.sm} {
            position: fixed;
            z-index: 1000;
            bottom: 32px;
            top: auto;
        }

        ${(props) =>
            props.theme.isLandscape &&
            css`
                ${props.theme.orientation.landscape} {
                    left: 16px;
                    top: calc(50% - 15px);
                    align-items: flex-start;
                    max-width: 200px;
                    min-width: auto;
                }
            `}

        &--error {
            color: ${(props) => props.theme.palette.secondaryA4};

            svg {
                margin-right: 8px;
            }
        }
    }

    .photo-hints {
        margin: 0;
        color: ${(props) => props.theme.palette.primaryA7};
        font-size: 16px;

        ${(props) => {
            if (props.theme.isLandscape) {
                return {
                    color: props.theme.palette.primaryA1,
                };
            }

            return undefined;
        }}

        ${(props) => props.theme.breakpointTo.md} {
            min-height: 52px;
        }

        span {
            color: ${(props) => props.theme.palette.primaryA1};
        }
    }

    .transparent {
        opacity: 0;
    }

    .loading-face-detector {
        display: flex;
        justify-content: center;
        align-items: center;
        position: fixed;
        top: calc(50% - 20px);

        ${(props) => props.theme.breakpointTo.sm} {
            position: fixed;
        }

        ${(props) => {
            if (props.theme.isLandscape) {
                return {
                    left: 0,
                    right: 0,
                };
            }

            return undefined;
        }}
    }

    .error-badge {
        text-align: left;
        //position: absolute;
        //bottom: 32px;
        background: #ffeef4;
        max-width: 362px;
        align-items: flex-start;

        svg {
            margin-top: 2px;
        }

        ${(props) => props.theme.breakpointTo.sm} {
            max-width: calc(100vw - 32px);
            font-size: 12px;
            padding: 4px 8px;

            svg {
                margin-top: 4px;
            }
        }
    }
`;
